import {DomainStore} from 'shared/store';
import {auth, endpoints, types} from 'shared/core';
import _ from 'lodash';
import {observable, action} from 'mobx';
import Cycle from 'stores/performance/Cycle';
import UiState from './UiState';
import {hasReviewees} from 'performance/tools';

class CycleState {
  store = new DomainStore();
  history;
  match;

  @observable allCycles = [];
  @observable cycle = null;
  @observable errors = {};
  @observable uiState = new UiState();
  @observable isLeader = false;

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;
  }

  @action async load() {
    await this.store._compose([
      endpoints.EMPLOYEES,
      endpoints.PERFORMANCE.CYCLES
    ]);

    this.allEmployees = this.store.getEmployees();
    this.allCycles = _.orderBy(
      this.store._getAll(types.PERFORMANCE.CYCLE).map(c => this.createCycle(c)),
      'sortOrder'
    );
    this.isLeader = hasReviewees(auth.employee, this.allCycles);
    if(this.match && this.match.params.id) {
      this.selectCycle(this.match.params.id);
    }
  }

  createCycle(json) {
    const cycle = new Cycle(json);
    cycle.init(this.allEmployees);

    return cycle;
  }

  async postCycle() {
    const response = await this.store.post(endpoints.PERFORMANCE.CYCLES, types.PERFORMANCE.CYCLE);
    const cycle = this.createCycle(response.model);
    this.allCycles.push(cycle);
    return cycle;
  }

  updateWithResponse({model, errors}) {
    if (model) {
      const index = _.findIndex(this.allCycles, {id: model.id});
      this.allCycles[index] = this.createCycle(model);
      this.selectCycle(model.id);
    }
    this.errors = errors;
  }

  async patchCycle(partialCycle) {
    const cycle = this.createCycle(partialCycle);
    const response = await this.store.patch(`${endpoints.PERFORMANCE.CYCLES}/${this.cycle.id}`,
      types.PERFORMANCE.CYCLE, cycle.toJS());
    this.updateWithResponse(response);
    return _.isEmpty(response.errors);
  }

  async archiveCycle(cycle) {
    const {model} = await this.store.post(cycle.links.archive.href, types.PERFORMANCE.CYCLE);

    if (model) {
      this.uiState.archiveCycle = null;
      cycle.status = model.status;
      cycle.links = model.links;
    }
  }

  async destroyCycle(cycle) {
    await this.store.destroy(cycle);
    this.allCycles.remove(cycle);
    this.uiState.deleteCycle = null;
  }

  resetCycle = () => {
    this.cycle && this.selectCycle(this.cycle.id);
    this.errors = {};
  };

  selectCycle(id) {
    this.cycle = this.createCycle(_.find(this.allCycles, {id}));
  }

  // =========================== Performance Index ===========================

  @action onCheckInCreated = async () => {
    const newCycle = await this.postCycle();
    this.history.push(newCycle.url);
  };

  @action onCycleClicked = (cycle) => {
    this.history.push(cycle.url);
  };

  @action onCycleDeleted = async (cycle) => {
    await this.destroyCycle(cycle);
  };

  @action onCycleArchived = async (cycle) => {
    await this.archiveCycle(cycle);
  };
}

export default CycleState;
